export enum MerchantCarrierReturnLabelMode {
  ONLY_REDO_CARRIERS = "only-redo-carriers",
  ONLY_SOME_COUNTRIES = "only-some-countries",
  ALWAYS = "always",
  CHEAPEST_OF_REDO_OR_MERCHANT = "cheapest-of-redo-or-merchant",
}
